"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "isNavigationKeyPress", {
  enumerable: true,
  get: function get() {
    return _Tracking.isNavigationKeyPress;
  }
});
Object.defineProperty(exports, "useAutoPageTracking", {
  enumerable: true,
  get: function get() {
    return _Tracking.useAutoPageTracking;
  }
});
Object.defineProperty(exports, "useFirstCapital", {
  enumerable: true,
  get: function get() {
    return _Strings.useFirstCapital;
  }
});
Object.defineProperty(exports, "useOnClickOutside", {
  enumerable: true,
  get: function get() {
    return _ClickOutside.useOnClickOutside;
  }
});
Object.defineProperty(exports, "useOnEdgeProximityDetect", {
  enumerable: true,
  get: function get() {
    return _EdgeProximityDetect.useOnEdgeProximityDetect;
  }
});
Object.defineProperty(exports, "useTracking", {
  enumerable: true,
  get: function get() {
    return _Tracking.useTracking;
  }
});
var _ClickOutside = require("./ClickOutside");
var _EdgeProximityDetect = require("./EdgeProximityDetect");
var _Strings = require("./Strings");
var _Tracking = require("./Tracking");